<div class="card">
  <app-header
    titulo="Processos de Integração"
    descricao="Gerenciamento de processos (fluxos) de integração de dados">
  </app-header>

  <p-table
    #dt
    [value]="processos"
    dataKey="id"
    [loading]="loading"
    [globalFilterFields]="['nome', 'descricao', 'criadoPor']"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">

    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <button pButton pRipple label="Novo Processo" icon="pi pi-plus" class="p-button-success mr-2" (click)="novoProcesso()"></button>
          <button pButton pRipple icon="pi pi-filter-slash" class="p-button-outlined" (click)="limparFiltros()" pTooltip="Limpar filtros" tooltipPosition="top"></button>
        </div>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="table.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar..." class="w-full" />
        </span>
        <button pButton pRipple icon="pi pi-refresh" class="p-button-outlined" (click)="carregarProcessos()" [loading]="loading" pTooltip="Atualizar" tooltipPosition="top"></button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5rem">Status</th>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
        <th pSortableColumn="criadoEm">Data Criação <p-sortIcon field="criadoEm"></p-sortIcon></th>
        <th style="width: 15rem; text-align: center;">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-processo>
      <tr>
        <td class="text-center">
          <p-button
            [icon]="getAtivoIcon(processo.ativo)"
            [pTooltip]="getAtivoLabel(processo.ativo)"
            tooltipPosition="top"
            [styleClass]="processo.ativo ? 'p-button-success' : 'p-button-danger'"
            (click)="toggleAtivo(processo)">
          </p-button>
        </td>
        <td><strong>{{ processo.nome }}</strong></td>
        <td>{{ processo.descricao }}</td>
        <td>{{ formatarData(processo.criadoEm) }}</td>
        <td class="text-center">
          <button pButton pRipple icon="pi pi-play" class="p-button-rounded p-button-success p-button-text" (click)="executarProcesso(processo)" pTooltip="Executar" tooltipPosition="top"></button>
          <button pButton pRipple icon="pi pi-sitemap" class="p-button-rounded p-button-info p-button-text" (click)="visualizarRecursos(processo)" pTooltip="Ver Fluxo/Recursos" tooltipPosition="top"></button>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" (click)="editarProcesso(processo)" pTooltip="Editar" tooltipPosition="top"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarProcesso(processo)" pTooltip="Deletar" tooltipPosition="top"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">Nenhum processo cadastrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
